import _ from 'lodash'

export const getPastAppointmentsNextPageParam = lastPage => {
  if (!lastPage) {
    return undefined
  }
  const nextUrl = lastPage.nextUrl
  if (!nextUrl || nextUrl === 'null' || nextUrl === '') {
    return undefined
  }
  return nextUrl
}

export const dedupPastAppointmentsAcrossPages = pages => {
  if (!Array.isArray(pages)) {
    return []
  }
  return _.uniqBy(
    pages.flatMap(page => page?.appointments ?? []),
    'appointmentId'
  )
}
